import {
    type StreamForStreamDashboard,
    type LessonForStreamDashboard,
    type StreamForDashboard,
    type LessonForDashboard,
} from 'Lessons';
import { getStreamLogInfo, isLessonComingSoonInStream } from './selectors';

/*
    Narrows the dashboard's stream to the StreamForDashboard shape that ContentAccess and
    ExamVerification take.

    The one field that needs work is comingSoon. LessonForDashboard carries it per lesson, but the show
    payload puts per-lesson coming-soon on chapters[].lessonHashes[], which is why
    isLessonComingSoonInStream needs the stream and not only the lesson.
*/

export function toLessonForDashboard(
    stream: StreamForStreamDashboard,
    lesson: LessonForStreamDashboard,
): LessonForDashboard {
    return {
        id: lesson.id,
        title: lesson.title,
        localePackId: lesson.localePackId,
        test: lesson.test,
        assessment: lesson.assessment,
        comingSoon: isLessonComingSoonInStream(stream, lesson),
        unrestricted: lesson.unrestricted,
    };
}

export function toStreamForDashboard(stream: StreamForStreamDashboard): StreamForDashboard {
    return {
        id: stream.id,
        title: stream.title,
        locale: stream.locale,
        exam: stream.exam,
        chapters: stream.chapters,
        localePackId: stream.localePackId,
        image: stream.image,
        requiresProctoring: stream.requiresProctoring,
        comingSoon: stream.comingSoon,
        lessons: stream.lessons.map(lesson => toLessonForDashboard(stream, lesson)),
    };
}

/*
    The shape SiteMetadata#contentDefaultShareInfo reads, which is the Iguana one: it takes
    entity_metadata.canonical_url, .tweet_template, .title and .description, all snake-cased. Handing it
    the vanilla stream throws on the first of those, so both share paths build this instead.
*/
export function toStreamForShareInfo(stream: StreamForStreamDashboard) {
    const entityMetadata = stream.entityMetadata;

    return {
        title: stream.title,
        description: stream.description,
        entity_metadata: {
            canonical_url: entityMetadata?.canonicalUrl ?? null,
            tweet_template: entityMetadata?.tweetTemplate ?? null,
            title: entityMetadata?.title ?? null,
            description: entityMetadata?.description ?? null,
        },
    };
}

// The shape the Angular certificate mixin and the LinkedIn directive read: id, exam and logInfo().
export function toStreamForAngular(stream: StreamForStreamDashboard) {
    return { id: stream.id, exam: stream.exam, logInfo: () => getStreamLogInfo(stream) };
}
